import type { AppRouteRecordRaw } from '@/router/types';

import { PAGE_NOT_FOUND_NAME, LAYOUT, REDIRECT_NAME } from '@/router/constant';
import { t } from '@/hooks/web/useI18n';

export const EXCEPTION_COMPONENT = () =>
    import('@/views/sys/exception/Exception.vue');

// 404 on a page
export const PAGE_NOT_FOUND_ROUTE: AppRouteRecordRaw = {
    path: '/:path(.*)*',
    name: PAGE_NOT_FOUND_NAME,
    component: LAYOUT,
    meta: {
        title: 'ErrorPage',
        hideBreadcrumb: true,
        hideMenu: true,
    },
    children: [
        {
            path: '/:path(.*)*',
            name: PAGE_NOT_FOUND_NAME,
            component: EXCEPTION_COMPONENT,
            meta: {
                title: 'ErrorPage',
                hideBreadcrumb: true,
                hideMenu: true,
            },
        },
    ],
};

export const REDIRECT_ROUTE: AppRouteRecordRaw = {
    path: '/redirect',
    component: LAYOUT,
    name: 'RedirectTo',
    meta: {
        title: REDIRECT_NAME,
        hideBreadcrumb: true,
        hideMenu: true,
    },
    children: [
        {
            path: '/redirect/:path(.*)',
            name: REDIRECT_NAME,
            component: () => import('/@/views/sys/redirect/index.vue'),
            meta: {
                title: REDIRECT_NAME,
                hideBreadcrumb: true,
            },
        },
    ],
};

// SVG Preview
export const SVG_PREVIEW: AppRouteRecordRaw = {
    path: '/svg',
    component: LAYOUT,
    name: 'SVGPreview',
    redirect: '/svg/display',
    meta: {
        title: t('routes.index.svgPreview'),
        hideBreadcrumb: true,
        hideMenu: true,
    },
    children: [
        {
            path: 'display',
            name: 'SVGDisplay',
            component: () => import('/@/views/sys/hidden/svg-preview.vue'),
            meta: {
                title: t('routes.index.svgPreview'),
                hideBreadcrumb: true,
            },
        },
    ],
};

// ANI Preview
export const ANI_PREVIEW: AppRouteRecordRaw = {
    path: '/ani',
    component: LAYOUT,
    name: 'ANIPreview',
    redirect: '/ani/display',
    meta: {
        title: t('routes.index.aniPreview'),
        hideBreadcrumb: true,
        hideMenu: true,
    },
    children: [
        {
            path: 'display',
            name: 'ANIDisplay',
            component: () => import('/@/views/sys/hidden/ani-preview.vue'),
            meta: {
                title: t('routes.index.aniPreview'),
                hideBreadcrumb: true,
            },
        },
    ],
}

// Experiment
export const EXPERIMENT: AppRouteRecordRaw = {
    path: '/experiment',
    component: LAYOUT,
    name: 'Experiment',
    redirect: '/experiment/display',
    meta: {
        title: t('routes.index.experiment'),
        hideBreadcrumb: true,
        hideMenu: true,
    },
    children: [
        {
            path: 'display',
            name: 'ExperimentDisplay',
            component: () => import('/@/views/sys/hidden/experiment.vue'),
            meta: {
                title: t('routes.index.experiment'),
                hideBreadcrumb: true,
            }
        }
    ]
}
